import styled from 'styled-components'

const CookieImageModalContainer = styled.div`
  display: flex;

`
export { CookieImageModalContainer }